import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z
  .object({
    code: z.string().optional(),
  })
  .passthrough();

export const Route = createFileRoute('/$locale/auth/deletion-status')({
  validateSearch: searchSchema,
});
